import core, { GQL } from '@gin-betting/core';

import {
    GET_FEATURED_TOURNAMENTS_REQUEST,
    GET_MISSING_MATCHES_REQUEST,
} from './constants';
import {
    GetFeaturedZoneConfigsRequestAction,
    GetFeaturedZoneConfigsRequestActionArgs,
} from './types';

const {
    entities: {
        actions: { makeGetMissingMatches },
    },
} = core;

export const getFeaturedZoneConfigs = (
    variables: GQL.GetFeaturedZoneConfigsQueryVariables,
    args: GetFeaturedZoneConfigsRequestActionArgs
): GetFeaturedZoneConfigsRequestAction => {
    return {
        type: GET_FEATURED_TOURNAMENTS_REQUEST,
        payload: {
            method: 'getFeaturedZoneConfigs',
            variables,
            args,
        },
        meta: { isApiCall: true },
    };
};

export const getMissingMatches = makeGetMissingMatches({
    type: GET_MISSING_MATCHES_REQUEST,
    withMarketsCount: true,
});

export const Actions = {
    getFeaturedZoneConfigs,
};
